import React from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';

export const CreditScoreSkipLayout = ({ afterSuccessfulSubmission }) => {
  return (
    <PXTextModalWrapper
      onSubmitSucces={afterSuccessfulSubmission}
    >
      <MetaControlField attr={'description'} />
    </PXTextModalWrapper>
  );
};

CreditScoreSkipLayout.propTypes = {
  afterSuccessfulSubmission: PropTypes.func,
};

CreditScoreSkipLayout.defaultProps = {
  afterSuccessfulSubmission: undefined,
};
